import { useMemo } from 'react';
import { useEventQuestions } from './useEventQuestions';


export const useUserQuestions = (eventId, userId) => {
    const questions = useEventQuestions(eventId);
    return useMemo(() => questions.filter(q => q.asker_id == userId), [questions]);
};
